import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { Check, X } from "lucide-react"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, checked, ...props }, ref) => {
  // Use checked prop if provided (controlled), otherwise use internal state (uncontrolled)
  const [internalChecked, setInternalChecked] = React.useState(checked ?? false)
  const isChecked = checked !== undefined ? checked : internalChecked

  React.useEffect(() => {
    if (checked !== undefined) {
      // Only update internal state if component is uncontrolled
    } else {
      setInternalChecked(checked ?? false)
    }
  }, [checked])

  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        isChecked ? "bg-green-500" : "bg-gray-300 dark:bg-gray-700",
        className
      )}
      checked={checked}
      onCheckedChange={(newChecked) => {
        if (checked === undefined) {
          setInternalChecked(newChecked)
        }
        props.onCheckedChange?.(newChecked)
      }}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none flex h-5 w-5 items-center justify-center rounded-full bg-white shadow-lg ring-0 transition-transform",
          isChecked ? "translate-x-5" : "translate-x-0"
        )}
      >
        {isChecked ? (
          <Check className="w-3 h-3 text-green-600" />
        ) : (
          <X className="w-3 h-3 text-gray-500" />
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  )
})
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
